import React from "react";
import { Sparkle, Info } from "lucide-react";

const outlets = [
  "New York Weekly",
  "Influencer Daily",
  "Atlanta Wire",
  "Economic Insider",
  "The Wall Street Times",
  "Entertainment Monthly News",
  "BLK",
  "US Insider",
  "The American News",
  "The Chicago Journal",
  "CEO Weekly",
  "New York Wire",
  "U.S. Business News",
  "Kivo Daily",
  "Entertainment Post",
  "Texas Today",
  "Net Worth",
  "Artist Weekly",
  "San Francisco Post",
  "Miami Wire",
  "Market Daily",
  "Women's Journal",
  "Music Observer",
  "Famous Times",
  "Real Estate Today",
  "Portland News",
  "Voyage New York",
  "Los Angeles Wire",
  "US Reporter",
  "World Reporter",
  "Celebrity",
  "California Gazette",
  "California Observer",
];

export default function MediaNetwork() {
  return (
    <section
      id="media-network"
      data-testid="media-network-section"
      className="relative bg-[#050505] py-16 md:py-24 lg:py-32 grain"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        {/* Masthead */}
        <div className="grid grid-cols-12 gap-6 mb-8 md:mb-12 lg:mb-16">
          <div className="col-span-12 md:col-span-3">
            <span className="text-[10px] uppercase tracking-[0.35em] text-[#7FB3D5]">
              ✦ Media Network
            </span>
            <p className="mt-6 text-[10px] uppercase tracking-[0.3em] text-white/40">
              Page 05
            </p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2
              data-testid="media-network-headline"
              className="font-display text-4xl md:text-6xl lg:text-7xl text-white leading-[0.95] tracking-tight font-light"
            >
              Media Network &amp;
              <span className="italic text-[#7FB3D5]"> Digital Press Reach</span>.
            </h2>
            <p className="mt-8 text-base md:text-lg text-white/65 leading-relaxed max-w-3xl">
              NOVA Media PR develops strategic media opportunities across
              digital press, podcasts, creator platforms, and brand-aligned
              visibility channels. Every campaign is tailored to your story
              angle, goals, audience, market, and timing.
            </p>
          </div>
        </div>

        {/* Outlet wall */}
        <div
          data-testid="media-outlet-wall"
          className="border border-white/10 bg-[#080808] p-6 md:p-10"
        >
          <p className="text-[10px] uppercase tracking-[0.35em] text-[#7FB3D5] mb-6 md:mb-8">
            ✦ Potential media &amp; digital press networks
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-5 md:gap-x-8 md:gap-y-7">
            {outlets.map((o, i) => (
              <React.Fragment key={o}>
                <span
                  data-testid={`outlet-${i}`}
                  className="font-display text-lg md:text-2xl lg:text-3xl text-white/85 font-light hover:text-[#7FB3D5] transition-colors duration-300 cursor-default leading-none"
                >
                  {o}
                </span>
                {i < outlets.length - 1 && (
                  <Sparkle
                    className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#7FB3D5] opacity-70 shrink-0"
                    fill="#7FB3D5"
                    strokeWidth={0.6}
                  />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Disclaimer */}
        <div
          data-testid="media-network-disclaimer"
          className="mt-10 md:mt-12 flex items-start gap-4 max-w-3xl border-l border-[#7FB3D5]/30 pl-6 py-2"
        >
          <Info
            className="w-4 h-4 text-[#7FB3D5] mt-1 shrink-0"
            strokeWidth={1.2}
          />
          <p className="text-xs md:text-sm text-white/55 leading-relaxed italic font-display">
            Placement opportunities are strategic and subject to media
            availability, campaign fit, story strength, editorial interest,
            and budget. NOVA Media PR focuses on optimizing visibility,
            credibility, and positioning through the most relevant
            opportunities for each campaign.
          </p>
        </div>
      </div>
    </section>
  );
}
